Platform.Deferred.execute(setCheckoutScript);

var giftWrappingOption = -1;
var creditAccountInitialised = false;
var root;

function setCheckoutScript() {
    root = $('body').data('root');

    var fbPixelEnabled = $('#checkout-form').data("fb-pixel");

    $('#checkout-info').click(function (e) {
        e.preventDefault();
        $('#checkout-modal').modal("show");
    });

    //// hide delivery address
    //if ($('#use-billing-cbx').prop('checked')) {
    //    $('#delivery-wrapper').hide();
    //    $('#delPickAddressWrapper').hide();
    //} else {
    //    $('#delivery-wrapper').show();
    //    $('#delPickAddressWrapper').show();
    //}
    //init calendar
    //$('.delivery-calendar-wrapper').on('focusin', '.delivery-calendar-picke', function(e) {
    //    $(this).datepicker(options);
    //});
    //$('.delivery-calendar-picker').datetimepicker({
    //    format: 'DD/MM/YYYY h:mm a',
    //    formatTime: 'h:mm a',
    //    formatDate: 'DD/MM/YYYY',
    //});

    //$(document).on('click', '#checkout-cart a.cart-remove', function () {
    //    var cartItemId = $(this).closest('tr').data('id');
    //    $.post(root + 'Cart/RemoveItem', { id: cartItemId }, ItemUpdated, 'json');
    //    return false;
    //});

    //$(document).on('change', '#checkout-cart select.cart-qty', function () {
    //    var cartItemId = $(this).closest('tr').data('id');
    //    var quantity = $(this).val();
    //    $.post(root + 'Cart/UpdateItemQuantity', {
    //        id: cartItemId,
    //        quantity: quantity
    //    }, ItemUpdated, 'json');
    //});

    //$(document).on("click", "#discount-btn", function (e) {
    //    AddDiscountCode();
    //    return false;
    //});

    //$(document).on('click', '.pf-checkout-cart-table .pf-qty-btn-minus', function (e) {
    //    e.preventDefault();
    //    var cartItemId = $(this).closest('tr').data('id');
    //    var wrapper = $(this).closest('.pf-qty-wrapper');
    //    var qtyTbx = wrapper.find('.pf-qty-select');
    //    var qty = Number(qtyTbx.val());
    //    if (qty > 1) {
    //        qty--;
    //        qtyTbx.val(qty);
    //        //UpdateTopCartQty(cartItemId, qty);
    //        UpdateItemCartQty(cartItemId, qty);
    //    }
    //});

    //$(document).on('click', '.pf-checkout-cart-table .pf-qty-btn-plus', function (e) {
    //    e.preventDefault();
    //    var cartItemId = $(this).closest('tr').data('id');
    //    var wrapper = $(this).closest('.pf-qty-wrapper');
    //    var qtyTbx = wrapper.find('.pf-qty-select');
    //    var qty = Number(qtyTbx.val());
    //    qty++;
    //    qtyTbx.val(qty);
    //    //UpdateTopCartQty(cartItemId, qty);
    //    UpdateItemCartQty(cartItemId, qty);
    //});

    //// Add handlers for top cart events, as when top cart changed need to refresh checkout cart
    //$(document).on('itemRemoved.topCart.platform', function (e, data) {
    //    if (data.result === 'ok')
    //        location.reload();
    //});
    //$(document).on('itemUpdated.topCart.platform', function (e, data) {
    //    if (data.result.substring(0, 2) === 'ok')
    //        location.reload();
    //});

    var userLoggedIn = $('#checkout-form').data("logged-in");
    if (userLoggedIn === 'True') {
        if ($('#billAddressPicker').val() === '-1')
            SetBillingAddressAuto();
        else
            SetBillingAddressSaved();

        if ($('#delAddressPicker').val() === '-1')
            SetDeliveryAddressAuto();
        else
            SetDeliveryAddressSaved();
    }

    $('#billPostcodeLookup').setupPostcodeLookup({
        api_key: 'ak_mmf2ua90pYdOfVBCry3SyDh5qKKOL',
        input_class: 'w-input input m-input postcode-lookup-input billPostcode',
        button_class: 'site-button postcode-lookup-btn pf-btn pf-btn-md pf-btn-primary',
        dropdown_class: 'w-input input m-input postcode-lookup-dropdown',
        //input: '#postcode-lookup-input',
        //button: '#postcode-lookup-btn',
        //dropdown_container: '#postcode-lookup-dropdown',
        output_fields: {
            line_1: '#billAddr1',
            line_2: '#billAddr2',
            //line_3: '#line3',
            post_town: '#billTown',
            county: '#billCounty',
            postcode: '#billPostcode'
        },
        onLookupSuccess: function (data) { },
        onLookupError: function () {/* Your custom code */ },
        onAddressSelected: function (elem, index) {
            GetDeliveryOptions();
            //var addressTxt = $('#billAddr1').val() + "\n" + $('#billAddr2').val();
            //$('#billing-auto-address-tbx').val(addressTxt);
            //$('#address-manually-btn').hide();
            //$('#address-wrapper').slideDown();
        }
    });

    $('#delPostcodeLookup').setupPostcodeLookup({
        api_key: 'ak_mmf2ua90pYdOfVBCry3SyDh5qKKOL',
        input_class: 'w-input input m-input postcode-lookup-input delPostcode',
        button_class: 'site-button postcode-lookup-btn pf-btn pf-btn-md pf-btn-primary',
        dropdown_class: 'w-input input m-input postcode-lookup-dropdown',
        //input: '#postcode-lookup-input',
        //button: '#postcode-lookup-btn',
        //dropdown_container: '#postcode-lookup-dropdown',
        output_fields: {
            line_1: '#delAddr1',
            line_2: '#delAddr2',
            //line_3: '#line3',
            post_town: '#delTown',
            county: '#delCounty',
            postcode: '#delPostcode'
        },
        onLookupSuccess: function (data) { },
        onLookupError: function () {/* Your custom code */ },
        onAddressSelected: function (elem, index) {
            GetDeliveryOptions();
            //var addressTxt = $('#billAddr1').val() + "\n" + $('#billAddr2').val();
            //$('#billing-auto-address-tbx').val(addressTxt);
            //$('#address-manually-btn').hide();
            //$('#address-wrapper').slideDown();
        }
    });

    $('#billing-address-manual-btn').click(function () {
        SetBillingAddressManual();
    });

    $('#billing-address-auto-btn').click(function () {
        SetBillingAddressAuto();
    });

    $('#billCountry').change(function (e) {
        e.preventDefault();
        if ($('#billCountry').val() != "GB") { // can only use lookup for UK addresses at the moment
            SetBillingAddressManual();
        }
        else {
            SetBillingAddressAuto();
        }
        GetDeliveryOptions();
        return false;
    });

    $('#delCountry').change(function (e) {
        e.preventDefault();
        if ($('#delCountry').val() != "GB") { // can only use lookup for UK addresses at the moment
            SetDeliveryAddressManual();
        }
        else {
            SetDeliveryAddressAuto();
        }
        GetDeliveryOptions();
        return false;
    });

    $('#delivery-address-manual-btn').click(function () {
        SetDeliveryAddressManual();
    });

    $('#delivery-address-auto-btn').click(function () {
        SetDeliveryAddressAuto();
    });

    $('#billPostcode').change(function () {
        GetDeliveryOptions();
    });
    $('#delPostcode').change(function () {
        GetDeliveryOptions();
    });

    $(document).on("click", ".deliveryOptionRbn", function (e) {
        var deliveryOptionId = $('input[name=deliveryOption]:radio:checked').val();
        GetDeliveryOptions(deliveryOptionId);
        return false;
    });


    $('#use-billing-cbx').click(function () {
        SetUseBilling();
        //var useBilling = $('#use-billing-cbx').is(':checked');
        //var billCountry = $('#billCountry').val();
        //var delCountry = $('#delCountry').val();
        //$.post("@Url.Action("ChangeDelivery", "Cart")", {useBilling: useBilling, billCountry: billCountry, delCountry: delCountry}, CountryChanged, "json");
        GetDeliveryOptions();
    });
    $(document).on("click", "#accountBalanceBtn", function () {
        ApplyAccountBalance();
    });

    $("#makePaymentBtn").click(function () {
        if (validateInput()) {
            $("#makePaymentBtn").text("Processing Order...");
            //$("#makePaymentBtn").css("color", "#000");
            // check stock
            if (fbPixelEnabled == "True") {
                fbq_ProcessPayment();
            }
            $('#checkout-form').submit();
        }
        else {
            $('#validate-errors').fadeIn();

        }
        return false;
    });

    $('#discount-input-tbx').blur(function () {
        $('#voucher-not-found').fadeOut();
    });

    $('#sagepayBtn').click(function () {
        var $useBillingCbx = $('#use-billing-cbx');
        $('#makePaymentBtn .pf-place-order-btn-text').text('Make Payment');
        //$('#customer-details').slideDown();
        //$('#delivery-note').show();
        $('#billing').slideDown();
        $('#useBillingBtn').show();
        if ($useBillingCbx.length > 0) $useBillingCbx.prop('checked', true);
        //$('#delivery-wrapper').hide();
        $('#delivery .checkout-step').text("4) ");
        SetUseBilling();
        GetDeliveryOptions();
    });
    $('#worldpayBGBtn').click(function () {
        var $useBillingCbx = $('#use-billing-cbx');
        $('#makePaymentBtn .pf-place-order-btn-text').text('Make Payment');
        //$('#customer-details').slideDown();
        //$('#delivery-note').show();
        $('#billing').slideDown();
        $('#useBillingBtn').show();
        if ($useBillingCbx.length > 0) $useBillingCbx.prop('checked', true);
        //$('#delivery-wrapper').hide();
        $('#delivery .checkout-step').text("4) ");
        SetUseBilling();
        GetDeliveryOptions();
    });
    $('#paypalBtn').click(function () {
        var $useBillingCbx = $('#use-billing-cbx');
        $('#makePaymentBtn .pf-place-order-btn-text').text('Make Payment');
        //$('#customer-details').slideUp();
        //$('#delivery-note').hide();
        if ($useBillingCbx.length > 0) $useBillingCbx.prop('checked', false);
        $('#useBillingBtn').hide();
        $('#billing').slideUp();
        //$('#delivery-wrapper').show();
        $('#delivery .checkout-step').text("3) ");
        SetUseBilling();
        GetDeliveryOptions();
    });
    $('#paypalGuestBtn').click(function () {
        var $useBillingCbx = $('#use-billing-cbx');
        $('#makePaymentBtn .pf-place-order-btn-text').text('Make Payment');
        //$('#customer-details').slideUp();
        //$('#delivery-note').hide();
        if ($useBillingCbx.length > 0) $useBillingCbx.prop('checked', false);
        $('#useBillingBtn').hide();
        $('#billing').slideUp();
        //$('#delivery-wrapper').show();
        $('#delivery .checkout-step').text("3) ");
        SetUseBilling();
        GetDeliveryOptions();
    });
    $('#payOnAccountBtn').click(function () {
        var $useBillingCbx = $('#use-billing-cbx');
        $('#makePaymentBtn .pf-place-order-btn-text').text('Place Order');
        //$('#customer-details').slideDown();
        //$('#delivery-note').show();
        $('#billing').slideDown();
        $('#useBillingBtn').show();
        if ($useBillingCbx.length > 0) $useBillingCbx.prop('checked', true);
        //$('#delivery-wrapper').hide();
        $('#delivery .checkout-step').text("4) ");
        SetUseBilling();
        GetDeliveryOptions();
    });
    $('.proformaInvoiceRadio').click(function () {
        var optionId = $(this).data('option-id');
        $('#proformaOptionId').val(optionId);
        var $useBillingCbx = $('#use-billing-cbx');
        $('#makePaymentBtn .pf-place-order-btn-text').text('Place Order');
        //$('#customer-details').slideDown();
        //$('#delivery-note').show();
        $('#billing').slideDown();
        $('#useBillingBtn').show();
        if ($useBillingCbx.length > 0) $useBillingCbx.prop('checked', true);
        //$('#delivery-wrapper').hide();
        $('#delivery .checkout-step').text("4) ");
        SetUseBilling();
        GetDeliveryOptions();
    });

    //var sagepay = $('#checkout-form').data('sagepay');
    //var paypal = $('#checkout-form').data('paypal');
    //if(sagepay == "True" && paypal == "True")
    //{
    //    $('#paypalBtn').trigger("click");
    //}
    $('#terms-cbx').click(function () {
        if ($('#terms-cbx').prop('checked')) {
            ValidNotes("", false);
        }
    });

    //$(document).on("click", ".editMessageBtn", function (e) {
    //    var id = $(this).closest('tr').attr('id');
    //    id = id.replace("prod-", "");
    //    var txt = $(this).prev('.personalMessageTxt').val();
    //    $(this).hide();
    //    $.post("@Url.Action("UpdatePersonalMessage", "Cart")", { pID: id, pMessageText: txt }, PersonalMessageUpdated, "json");
    //    return false;
    //});

    $('.gift-option-radio').change(function () {
        giftWrappingOption = $(this).val();
        GetDeliveryOptions();
    });

    $('#billAddressPicker').on('change', function () {
        var addressId = this.value;
        if (addressId === '-1') {
            $('#billAddr1').val('');
            $('#billAddr2').val('');
            $('#billTown').val('');
            $('#billCounty').val('');
            $('#billPostcode').val('');
            $('#billCountry').val('GB');
            $('#billPostcodeLookup select').val('open');
            SetBillingAddressAuto();
            GetDeliveryOptions();
        } else {
            $.post(root + 'UserAccount/GetAddress', {
                addressId: addressId
            }, function (response) {
                if (response.result === 'ok') {
                    $('#billAddr1').val(response.address.Address1);
                    $('#billAddr2').val(response.address.Address2);
                    $('#billTown').val(response.address.Town);
                    $('#billCounty').val(response.address.County);
                    $('#billPostcode').val(response.address.Postcode);
                    $('#billCountry').val(response.address.Country);
                    SetBillingAddressSaved();
                    GetDeliveryOptions();
                } else {
                    alert('Error getting address: ' + response.error);
                }
            });
        }
    });

    $('#delAddressPicker').on('change', function () {
        var addressId = this.value;
        if (addressId === '-1') {
            $('#delAddr1').val('');
            $('#delAddr2').val('');
            $('#delTown').val('');
            $('#delCounty').val('');
            $('#delPostcode').val('');
            $('#delCountry').val('GB');
            $('#delPostcodeLookup select').val('open');
            SetDeliveryAddressAuto();
            GetDeliveryOptions();
        } else {
            $.post(root + 'UserAccount/GetAddress', {
                addressId: addressId
            }, function (response) {
                if (response.result === 'ok') {
                    $('#delAddr1').val(response.address.Address1);
                    $('#delAddr2').val(response.address.Address2);
                    $('#delTown').val(response.address.Town);
                    $('#delCounty').val(response.address.County);
                    $('#delPostcode').val(response.address.Postcode);
                    $('#delCountry').val(response.address.Country);
                    SetDeliveryAddressSaved();
                    GetDeliveryOptions();
                } else {
                    alert('Error getting address: ' + response.error);
                }
            });
        }
    });

    // Init after events registered
    GetDeliveryOptions();
    InitUseBilling();
    InitPaymentMethods();
}

function InitUseBilling() {
    if ($('#use-billing-cbx').is(':checked')) {
        $('#delivery-wrapper').hide();
        $('#delPickAddressWrapper').hide();
    } else {
        $('#delivery-wrapper').show();
        $('#delPickAddressWrapper').show();
    }
}

function SetUseBilling() {
    if ($('#use-billing-cbx').is(':checked')) {
        $('#delivery-wrapper').slideUp();
        $('#delPickAddressWrapper').hide();
    } else {
        $('#delPickAddressWrapper').show();
        $('#delivery-wrapper').slideDown();
    }
}

//function ItemUpdated(data) {
//    if (data.result == "ok") {
//        location.reload();
//    } else if (data.result == "ok-stock-limited") {
//        //$('#site-msg-modal-header').html("Information");
//        //$('#site-msg-modal-msg').html("Sorry there are only " + data.qty + " of these items available in stock.");
//        //$('#site-msg-modal').modal('show');
//        alert("Sorry there are only " + data.qty + " of these items available in stock.");
//        location.reload();
//    } else if (data.result == "ok-out-of-stock") {
//        //$('#site-msg-modal-header').html("Information");
//        //$('#site-msg-modal-msg').html("Sorry this item is no longer in stock.");
//        //$('#site-msg-modal').modal('show');
//        alert("Sorry this item is no longer in stock.");
//        location.reload();
//    }
//}

//function PersonalMessageUpdated(data) {
//    if (data.result == "ok") {
//        var id = data.id;
//        var tr = $('#prod-' + id);
//        var span = $(tr).find('.ajaxResult');
//        var btn = $(tr).find('.editMessageBtn');
//        span.text("Your personal message has been updated");
//        $(btn).fadeIn();
//        $(span).fadeIn();
//        setTimeout(function () {
//            $(span).fadeOut("slow", function () {
//            });
//        }, 3000);
//    }
//}

function AddVoucherDone(data) {
    if (data.result == "ok") {
        location.reload();
    }
    else if (data.result == "fail") {
        // error
        alert("Error: " + data.err);
    }
    else if (data.msg == "order-total-not-reached") {
        $('#voucher-not-found').find('.pf-alert-msg').text("Discount only applies to orders over £" + parseFloat(data.amount).toFixed(2));
        $('#voucher-not-found').fadeIn();
    }
    else if (data.msg == "limit-reached") {
        $('#voucher-not-found').find('.pf-alert-msg').text("This discount code has reached its usage limit");
        $('#voucher-not-found').fadeIn();
    }
    else {
        $('#voucher-not-found').find('.pf-alert-msg').text("Invalid Discount Code");
        $('#voucher-not-found').fadeIn();
    }
}

function validateInput() {
    $.validity.setup({ outputMode: "summary" });

    // Start validation:
    $.validity.start();

    var emailCheckRegex = /\S+@\S+\.\S+/;
    var $useBillingCbx = $('#use-billing-cbx');

    var billEmail = $('#billEmail').val();
    var billAddr1 = $('#billAddr1').val();
    var billTown = $('#billTown').val();
    var billCounty = $('#billCounty').val();
    var billPostcode = $('#billPostcode').val();
    var billCountry = $('#billCountry').val();
    var delEmail = $('#delEmail').val();
    var delAddr1 = $('#delAddr1').val();
    var delTown = $('#delTown').val();
    var delCounty = $('#delCounty').val();
    var delPostcode = $('#delPostcode').val();
    var delCountry = $('#delCountry').val();
    var userLoggedIn = $('#checkout-form').data("logged-in");
    if ($('#delAddressPicker').val() === '-1' || userLoggedIn !== 'True') {
        // PAYPAL
        if ($('#paypalBtn').is(':checked') || $('#paypalGuestBtn').is(':checked')) {
            $('.required-input-delivery').require();
            if (!$useBillingCbx.is(':checked')) {
                if (!emailCheckRegex.test(delEmail)) {
                    ValidNotes('Please check that your email address is entered correctly.', true);
                    $('#delEmail').addClass('validity-erroneous');
                    return false;
                }
            }
        }

        // SAGEPAY / WORLDPAY
        if ($('#sagepayBtn').is(':checked') || $('#worldpayBGBtn').is(':checked')) {
            $('.required-input').require();
            if (!$useBillingCbx.is(':checked')) {
                $('.required-input-delivery').require();
            }
        }

        // ACCOUNT / PROFORMA INVOICE
        if ($('#payOnAccountBtn').is(':checked') || ($('.proformaInvoiceRadio:checked').length > 0)) {
            $('.required-input:not(#billCounty)').require();
            if (!$useBillingCbx.is(':checked')) {
                $('.required-input-delivery:not(#delCounty)').require();
            }
        }
    }

    if ($('#customerOrderRef').hasClass('required')) {
        $('#customerOrderRef').require();
    }

    // All of the validator methods have been called:
    // End the validation session:
    var result = $.validity.end();

    if (!result.valid) {
        ShowAllBillingAddressFields();
        ShowAllDeliveryAddressFields();
    }

    if ($('#delAddressPicker').val() === '-1') {
        // PAYPAL 2nd check
        if ($('#paypalBtn').is(':checked') || $('#paypalGuestBtn').is(':checked')) {
            if (result.valid) {
                if (delCountry === 'US' && delCounty.length !== 2) {
                    ValidNotes('Please use only 2 characters for U.S. States, i.e. for Florida put "FL".', true);
                    $('#delCounty').addClass('validity-erroneous');
                    return false;
                }
            } else {
                ValidNotes('Please complete all the highlighted fields marked above to continue.', true);
            }
        }
    }

    // SAGEPAY 2nd check
    if ($('#sagepayBtn').is(':checked') || $('#worldpayBGBtn').is(':checked') || $('#payOnAccountBtn').is(':checked') || ($('.proformaInvoiceRadio:checked').length > 0)) {
        if (result.valid) {
            // check email
            if ($('#billAddressPicker').val() === '-1') {
                if (!emailCheckRegex.test(billEmail)) {
                    ValidNotes('Please check that your email address is entered correctly.', true);
                    $('#billEmail').addClass('validity-erroneous');
                    return false;
                }
            }
            if ($('#delAddressPicker').val() === '-1') {
                if (!$useBillingCbx.is(':checked')) {
                    if (!emailCheckRegex.test(delEmail)) {
                        ValidNotes('Please check that your email address is entered correctly.', true);
                        $('#delEmail').addClass('validity-erroneous');
                        return false;
                    }
                }
            }

            // for US make sure only 2 characters
            if ($('#billAddressPicker').val() === '-1') {
                if (billCountry === 'US' && billCounty.length !== 2) {
                    ValidNotes('Please use only 2 characters for U.S. States, i.e. for Florida put "FL".', true);
                    $('#billCounty').addClass('validity-erroneous');
                    return false;
                }
            }
            if ($('#delAddressPicker').val() === '-1') {
                if (delCountry === 'US' && delCounty.length !== 2) {
                    ValidNotes('Please use only 2 characters for U.S. States, i.e. for Florida put "FL".', true);
                    $('#delCounty').addClass('validity-erroneous');
                    return false;
                }
            }
        } else {
            ValidNotes('Please complete all the highlighted fields marked above to continue.', true);
        }
    }

    var requireTerms = $('#checkout-form').data('require-terms');
    if (typeof requireTerms === 'undefined' || requireTerms === 'True') {
        if (result.valid) {
            if (!$('#terms-cbx').is(':checked')) {
                ValidNotes('Please confirm you agree to the website terms and conditions above.', true);
                $('.pf-terms').addClass('validity-erroneous');
                return false;
            }
        }
    }

    // Return whether it's okay to proceed with the Ajax:
    return result.valid;
}

function ValidNotes(text, show) {
    if (show) {
        $('#validNotes').html(text);
        $('#validNotes').fadeIn();
    } else {
        $('#validNotes').fadeOut();
    }
}
function ApplyAccountBalance(deliveryOptionId) {
    var useBilling = $('#use-billing-cbx').is(':checked');
    var countryCode;
    var postcode;
    if (useBilling) {
        countryCode = $('#billCountry').val();
        postcode = $('#billPostcode').val();
    } else {
        countryCode = $('#delCountry').val();
        postcode = $('#delPostcode').val();
    }
    var paymentType = $('input[name=paymentType]:checked', '#paymentMethods').val();

    $.post(root + "Checkout/GetDeliveryOptionsAndTotals", {
        countryCode: countryCode,
        postcode: postcode,
        deliveryOptionId: deliveryOptionId,
        giftWrappingOptionId: giftWrappingOption,
        paymentType: paymentType,
        useAccountBalance: true
    }, function (data) {
        $('#delivery-options-frame').html(data);
        var deliveryOptionsExist = $('input[name=deliveryOption]').length > 0;
        var accountBalanceEnabled = $('input[name=accountBalanceEnabled]').val();
        if (deliveryOptionsExist)
            $('#makePaymentBtn').show();
        else
            $('#makePaymentBtn').hide();
        if (accountBalanceEnabled == "True") {
            if (paymentType == "payOnAccount") {
                var userCannotPay = $('input[name=AccountBalanceLessThanTotal]').val();
                if (userCannotPay == "True") {
                    $('#makePaymentBtn').hide();
                }
            }
        }
    });
}
// loads delivery options view
function GetDeliveryOptions(deliveryOptionId) {
    var useBilling = $('#use-billing-cbx').is(':checked');
    var countryCode;
    var postcode;
    if (useBilling) {
        countryCode = $('#billCountry').val();
        postcode = $('#billPostcode').val();
    } else {
        countryCode = $('#delCountry').val();
        postcode = $('#delPostcode').val();
    }
    var paymentType = $('input[name=paymentType]:checked', '#paymentMethods').val();
    if (!deliveryOptionId)
        deliveryOptionId = $('input[name=deliveryOption]:radio:checked').val();

    $.post(root + "Checkout/GetDeliveryOptionsAndTotals", {
        countryCode: countryCode,
        postcode: postcode,
        deliveryOptionId: deliveryOptionId,
        giftWrappingOptionId: giftWrappingOption,
        paymentType: paymentType,
        useAccountBalance: false
    }, function (data) {
        $('#delivery-options-frame').html(data);
        var deliveryOptionsExist = $('input[name=deliveryOption]').length > 0;
        var accountBalanceEnabled = $('input[name=accountBalanceEnabled]').val();
        var $payOnAccountButton = $('#payOnAccountBtn');
        var creditAccountDisablePayOnAccount = $('.order-totals').data('credit-account-disable-pay-on-account');
        if (deliveryOptionsExist)
            $('#makePaymentBtn').show();
        else
            $('#makePaymentBtn').hide();
        if (accountBalanceEnabled == "True") {
            if (paymentType == "payOnAccount") {
                var userCannotPay = $('input[name=AccountBalanceLessThanTotal]').val();
                if (userCannotPay == "True") {
                    $('#makePaymentBtn').hide();
                }
            }
        }
        if ($payOnAccountButton.length > 0 && creditAccountDisablePayOnAccount !== undefined) {
            var $creditAccountAvailableMessage = $('.pf-checkout-credit-account-available-message');
            var $creditAccountUnavailableMessage = $('.pf-checkout-credit-account-unavailable-message');
            $payOnAccountButton.prop('disabled', creditAccountDisablePayOnAccount);
            if (creditAccountDisablePayOnAccount) {
                if ($payOnAccountButton.prop('checked') && creditAccountInitialised) {
                    Lobibox.notify('warning', {
                        msg: 'Insufficient available credit for payment on account, please choose another payment method',
                        icon: 'fas fa-info-circle',
                        title: 'Payment on Account Not Available'
                    });
                }
                if ($payOnAccountButton.prop('checked') || !creditAccountInitialised) {
                    $payOnAccountButton.prop('checked', false);
                    $('input[name=paymentType]:not(:disabled):first').prop('checked', true).click();
                }
                $creditAccountAvailableMessage.hide();
                $creditAccountUnavailableMessage.show();
            } else {
                $creditAccountUnavailableMessage.hide();
                $creditAccountAvailableMessage.show();
            }
            creditAccountInitialised = true;
        }
    });
}

function InitPaymentMethods() {
    $("#paymentMethods input:radio:first").prop('checked', true).click();
}


// address lookup 
function SetBillingAddressAuto() {
    var $checkoutForm = $('#checkout-form');
    if ($checkoutForm.data('billing-enable-saved-address') === 'True') {
        var enableUnsaved = $checkoutForm.data('billing-enable-unsaved-address') === 'True';
        $('#billSaveAddress').prop('disabled', !enableUnsaved);
    }
    $('#billAddr1').prop('disabled', false);
    $('#billAddr2').prop('disabled', false);
    $('#billTown').prop('disabled', false);
    $('#billCounty').prop('disabled', false);
    $('#billPostcode').prop('disabled', false);
    $('#billCountry').prop('disabled', false);
    $('#billing-address-auto-btn').show();
    $('#billing-manual-wrapper').slideUp();
    $('#billing-auto-wrapper').show();
}

function SetBillingAddressSaved() {
    var $checkoutForm = $('#checkout-form');
    if ($checkoutForm.data('billing-enable-saved-address') === 'True') {
        $('#billSaveAddress').prop('checked', true).prop('disabled', true);
    }
    $('#billAddr1').prop('disabled', true);
    $('#billAddr2').prop('disabled', true);
    $('#billTown').prop('disabled', true);
    $('#billCounty').prop('disabled', true);
    $('#billPostcode').prop('disabled', true);
    $('#billCountry').prop('disabled', true);
    $('#billing-address-auto-btn').hide();
    $('#billing-manual-wrapper').slideDown();
    $('#billing-auto-wrapper').hide();
}

function SetBillingAddressManual() {
    var $checkoutForm = $('#checkout-form');
    if ($checkoutForm.data('billing-enable-saved-address') === 'True') {
        var enableUnsaved = $checkoutForm.data('billing-enable-unsaved-address') === 'True';
        $('#billSaveAddress').prop('disabled', !enableUnsaved);
    }
    $('#billAddr1').prop('disabled', false);
    $('#billAddr2').prop('disabled', false);
    $('#billTown').prop('disabled', false);
    $('#billCounty').prop('disabled', false);
    $('#billPostcode').prop('disabled', false);
    $('#billCountry').prop('disabled', false);
    $('#billing-address-auto-btn').show();
    $('#billing-manual-wrapper').slideDown();
    $('#billing-auto-wrapper').hide();
}

function ShowAllBillingAddressFields() {
    if ($('#checkout-form').data('logged-in') === 'False' || $('#billAddressPicker').val() === '-1')
        $('#billing-address-auto-btn').show();

    $('#billing-manual-wrapper').slideDown();
    $('#billing-auto-wrapper').hide();
}

// delivery
function SetDeliveryAddressAuto() {
    var $checkoutForm = $('#checkout-form');
    if ($checkoutForm.data('delivery-enable-saved-address') === 'True') {
        var enableUnsaved = $checkoutForm.data('delivery-enable-unsaved-address') === 'True';
        $('#delSaveAddress').prop('disabled', !enableUnsaved);
    }
    $('#delSaveAddress').prop('disabled', false);
    $('#delAddr1').prop('disabled', false);
    $('#delAddr2').prop('disabled', false);
    $('#delTown').prop('disabled', false);
    $('#delCounty').prop('disabled', false);
    $('#delPostcode').prop('disabled', false);
    $('#delCountry').prop('disabled', false);
    $('#delivery-address-auto-btn').show();
    $('#delivery-manual-wrapper').slideUp();
    $('#delivery-auto-wrapper').show();
}

function SetDeliveryAddressSaved() {
    var $checkoutForm = $('#checkout-form');
    if ($checkoutForm.data('delivery-enable-saved-address') === 'True') {
        $('#delSaveAddress').prop('checked', true).prop('disabled', true);
    }
    $('#delAddr1').prop('disabled', true);
    $('#delAddr2').prop('disabled', true);
    $('#delTown').prop('disabled', true);
    $('#delCounty').prop('disabled', true);
    $('#delPostcode').prop('disabled', true);
    $('#delCountry').prop('disabled', true);
    $('#delivery-address-auto-btn').hide();
    $('#delivery-manual-wrapper').slideDown();
    $('#delivery-auto-wrapper').hide();
}

function SetDeliveryAddressManual() {
    var $checkoutForm = $('#checkout-form');
    if ($checkoutForm.data('delivery-enable-saved-address') === 'True') {
        var enableUnsaved = $checkoutForm.data('delivery-enable-unsaved-address') === 'True';
        $('#delSaveAddress').prop('disabled', !enableUnsaved);
    }
    $('#delAddr1').prop('disabled', false);
    $('#delAddr2').prop('disabled', false);
    $('#delTown').prop('disabled', false);
    $('#delCounty').prop('disabled', false);
    $('#delPostcode').prop('disabled', false);
    $('#delCountry').prop('disabled', false);
    $('#delivery-address-auto-btn').show();
    $('#delivery-manual-wrapper').slideDown();
    $('#delivery-auto-wrapper').hide();
}

function ShowAllDeliveryAddressFields() {
    if ($('#checkout-form').data('logged-in') === 'False' || $('#delAddressPicker').val() === '-1')
        $('#delivery-address-auto-btn').show();

    $('#delivery-manual-wrapper').slideDown();
    $('#delivery-auto-wrapper').hide();
}

//function UpdateItemCartQty(cartId, qty) {
//    $.post(root + "Cart/UpdateItemQuantity", {
//        id: cartId,
//        quantity: qty
//    }, function (data) {
//        // Display warnings if relevant
//        if (data.result === 'ok-stock-limited')
//            alert('Sorry, there are only ' + data.qty + ' of these items available in stock.');
//        else if (data.result === 'ok-out-of-stock')
//            alert('Sorry, this item is no longer in stock.');

//        // Fire event
//        //$(document).trigger('itemUpdated.mainCart.platform', data);

//        // Refresh page if response OK
//        if (data.result.substring(0, 2) === 'ok') {
//            location.reload();
//            //GetTopCart();
//            //SetCartQty();
//        }
//    }, 'json');
//}

function CheckMinimumOrder() {
    $.get(root + 'Checkout/ReachedMinimumOrder', function (response) {
        var $makePaymentArea = $('.pf-checkout-actions');
        if (response.reachedMinimumOrder)
            $makePaymentArea.show();
        else
            $makePaymentArea.hide();
    });
}

function CheckItemsCount() {
    $.get(root + 'Checkout/CheckItemsCount', function (response) {
        var $makePaymentArea = $('.pf-checkout-actions');
        if (response.hasItems)
            $makePaymentArea.show();
        else
            $makePaymentArea.hide();
    });
}

// Register handlers for cart actions
$(document).on('itemUpdated.cart.platform', function (event, data) {
    GetDeliveryOptions();
    CheckMinimumOrder();
    CheckItemsCount();
});

$(document).on('itemRemoved.cart.platform', function (event, data) {
    GetDeliveryOptions();
    CheckMinimumOrder();
    CheckItemsCount();
});

$(document).on('discountUpdated.cart.platform', function (event, data) {
    GetDeliveryOptions();
    CheckMinimumOrder();
    CheckItemsCount();
});